export type ClassValue = string | false | null | undefined;

/** Joins truthy class names into a single space-separated string. */
export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
